export const DASHBOARD_PREFIX = 'dashboard-';
export const DASHBOARD_DEFAULT_BASE_NAME = 'My Dashboard';
